angular.module('elfium').controller('reportTableController', ['$scope', '$q', 'reportService', 'reportDtoService', 'reportYearService', 'reportContentService', 'REPORT_PHASE', 'TASK_TYPES',
    function ($scope, $q, reportService, reportDtoService, reportYearService, reportContentService, REPORT_PHASE, TASK_TYPES) {
        var that = this;
        that.reportsByTypesUnchanged = {};
        $scope.taskTypeOrder = [TASK_TYPES.KOTEVRENI, TASK_TYPES.POTREBA, TASK_TYPES.NABIDKA, TASK_TYPES.KUZAVRENI];
        $scope.reportPhaseOrder = [REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA, REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA, REPORT_PHASE.CHCI_NABIDKU, REPORT_PHASE.PRVNI_PREDANI_NABIDKY, REPORT_PHASE.ROZHODNUTI_O_NABIDCE, REPORT_PHASE.ZADANI_DO_PT];
        that.loadReports = function (businessCaseId) {
            if (businessCaseId) {
                reportService.getReportsByBusinessCaseId(businessCaseId).then(function (reportsByTypes) {
                    if (Object.keys(reportsByTypes).length > 1) {
                        that.reportsByTypesUnchanged = angular.copy(reportsByTypes);
                        $scope.reportsByTypes = reportsByTypes;
                    }
                });
            }
        };
        that.saveReports = function (businessCaseId) {
            if (reportContentService.hasFirstItemInActual($scope.reportsByTypes)) {
                if (reportContentService.isActualLocked($scope.reportsByTypes) && $scope.lockedZadaniDoPT) {
                    return reportYearService.openEditDetailModal(businessCaseId).finally(() => that.doSaveReports(businessCaseId));
                } else {
                    return that.doSaveReports(businessCaseId);
                }
            } else {
                return $q.reject('Vyplňte povinné údaje: Realita/0-K Otevření/Otevření případu');
            }
        };
        that.doSaveReports = function (businessCaseId) {
            return reportService.updateReports(businessCaseId, $scope.reportsByTypes, that.reportsByTypesUnchanged).then(function () {
                that.reportsByTypesUnchanged = angular.copy($scope.reportsByTypes);
            }); 
        }
        that.$onInit = function () {
            that.reportsByTypesUnchanged = {};
            $scope.lockedZadaniDoPT = false;
        	$scope.reportsByTypes = reportService.buildInitialReport();
        };
        that.setReportsByTypes = function (reportsByTypes) {
            that.reportsByTypesUnchanged = angular.copy(reportsByTypes);
            $scope.reportsByTypes = reportsByTypes;
        };
        that.getDayDiff = function (date1, date2) {
            var dateDifference = new Date(date1).getTime() - new Date(date2).getTime();
            return Math.round(dateDifference / (1000 * 60 * 60 * 24));
        };
        that.updateIsDirty = function () {
            $scope.isDirty = !angular.equals(that.reportsByTypesUnchanged, $scope.reportsByTypes);
        };
        $scope.$watch('reportsByTypes', that.updateIsDirty, true);
        $scope.$watch(function () {
            return that.reportsByTypesUnchanged;
        }, that.updateIsDirty);
        that.getReportRow = function (reportRows, index) {
            var hasReportRows = reportRows && reportRows.length > index;
            return hasReportRows ? reportRows[index] : null;
        };
        that.calculateDifference = function (report, index, currentValue, calculationCallback) {
            var difference = '';
            if (currentValue) {
                var reportRow;
                if (index == 0) {
                    reportRow = that.getReportRow(report.plan, index);
                } else {
                    reportRow = that.getReportRow(report.actual, index - 1);
                }
                difference = calculationCallback(currentValue, reportRow) 
            } else {
                difference = '-';
            }
            return difference;
        };
        $scope.getDateDifference = function (report, index) {
            return that.calculateDifference(report, index, report.actual[index].date, function (currentValue, reportRow) {
                return that.getDayDiff(currentValue, reportRow.date);
            });
        };
        $scope.getVolumeDifference = function (report, index) {
            return that.calculateDifference(report, index, report.actual[index].volume, function (currentValue, reportRow) {
                return currentValue - reportRow.volume;
            });
        };
        $scope.getDiffClass = function (diffValue) {
            var resultClass = '';
            if (diffValue >= 0) {
                resultClass = 'green';
            } else if (diffValue < 0) {
                resultClass = 'red';
            }
            return resultClass;
        };
        $scope.addReportItem = function (report) {
            var lastActual = report[report.length - 1];
        	var newReportItem = reportDtoService.buildReportDto({
                termin: lastActual.date,
                objem: lastActual.volume
            });
        	report.push(newReportItem);
        };
        $scope.removeReportItem = function (report, reportItem) {
            var index = report.indexOf(reportItem);
            if (index != -1) {
                report.splice(index, 1);
            }
        };
        $scope.updateCallback = function (businessCaseId) {
            businessCaseId = businessCaseId || $scope.businessCaseId;
            return that.saveReports(businessCaseId);
        };
        $scope.isReportLocked = function (report) {
            var isReportLocked = false;
            angular.forEach(report.actual, function (actual) {
                if (actual.isLocked) {
                    isReportLocked = true;
                }
            });
            return isReportLocked;
        };
        $scope.isLockingAllowed = function (phase, report) {
            return reportContentService.isLockingAllowed($scope.reportsByTypes, phase, report) && !$scope.isReportLocked(report);
        };
        $scope.lockReport = function (phase, reportByPhase) {
            if (phase === REPORT_PHASE.ZADANI_DO_PT) {
                $scope.lockedZadaniDoPT = true;
            }
            reportContentService.lockReport(phase, reportByPhase);
        };
        $scope.shouldShowYearlyReport = function () {
            return reportContentService.isActualLocked(that.reportsByTypesUnchanged);
        };
        $scope.$watch('businessCaseId', that.loadReports);
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportTableController.ts